var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentObjectiveSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_378",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    transform: "translate(18 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18, -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_378-2",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(18 12)",
    fill: "#4984b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4713",
    transform: "translate(9.1 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron",
    transform: "translate(18.533 12.468) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    d: "M3156.241,3814.5l6.234,6.234,6.234-6.234",
    transform: "translate(-3156.241 -3814.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chevron-2",
    transform: "translate(6.234) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1664-2",
    d: "M3156.241,3814.5l6.234,6.234,6.234-6.234",
    transform: "translate(-3156.241 -3814.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentObjectiveSlider);
export default __webpack_public_path__ + "static/media/investment_objective_slider.4f0619a0f13fcc044f021f4a7e921126.svg";
export { ForwardRef as ReactComponent };